const menuSelectors = {
  searchButton: '.search-button',
  header: 'header',
  drawer: '#CartDrawer',
  drawerOverlay: '#DrawerOverlay',
  searchInput: '#search-input',
  searchInputMock: '#search-input-mock',
  body: 'body',
  loginButton: '.site-header [href="/account/login"]',
  cartButton: '.site-header [href="/cart"]',
  navDrawer: '#NavDrawer',
};

const loginButton = document.querySelector(menuSelectors.loginButton);
const body = document.querySelector(menuSelectors.body);
if (window.innerWidth > 767) document.querySelector(menuSelectors.drawerOverlay).style.display = 'none';

/**
 * Calculate drawer position
 *
 */
function calculateDrawerPosition() {
  const headerCoords = document.querySelector(menuSelectors.header).getBoundingClientRect();
  const drawer = document.querySelector(menuSelectors.drawer);
  drawer.style.top = `${headerCoords.bottom}px`;
}

/**
 * Debounce function
 *
 * @param {Function} func function to debounce
 * @param {number} timeout debounce period
 * @returns {Function} debounced function
 */
function debounce(func, timeout = 500) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

/**
 * Close drawer
 *
 * @param {event} e event
 */
function clickedOutside(e) {
  if (window.timber.LeftDrawer.drawerIsOpen) {
    if (e.target.closest(menuSelectors.drawer)
    || e.target.closest(menuSelectors.searchInputMock)
    || e.target.closest(menuSelectors.navDrawer)) return;
  }
  if (window.timber.RightDrawer.drawerIsOpen) {
    if (e.target.closest(menuSelectors.drawer)
    || e.target.closest(menuSelectors.searchInputMock)
    || e.target.closest(menuSelectors.navDrawer)) return;
  }
  if (window.timber.LeftDrawer.drawerIsOpen) {
    window.timber.LeftDrawer.close();
  }
  if (window.timber.RightDrawer.drawerIsOpen) {
    window.timber.RightDrawer.close();
  }
  // eslint-disable-next-line
  loginButton.removeEventListener('click', clickedLoginButton);
}

/**
 * Changes login button behaviour when search drawer is open
 *
 */
function clickedLoginButton() {
  window.location.pathname = '/account/login';
  loginButton.removeEventListener('click', clickedLoginButton);
}

/**
 * Called on search
 *
 * @param {event} e event
 */
function searchByValue(e) {
  calculateDrawerPosition();
  document.querySelector(menuSelectors.searchButton).click();
  document.querySelector('.input-group').style.display = 'none';
  document.querySelector(menuSelectors.searchInput).value = e.target.value;
  document.querySelector(menuSelectors.searchInput).dispatchEvent(new Event('change', { bubbles: true }));
  document.querySelector('#CartDrawer').removeAttribute('tabindex');
  document.querySelector(menuSelectors.searchInputMock).focus();
  loginButton.addEventListener('click', clickedLoginButton);
}

document.querySelectorAll(menuSelectors.searchInputMock).forEach((input) => {
  input.addEventListener('input', debounce((e) => searchByValue(e)));
});
document.querySelectorAll(menuSelectors.loginButton).forEach((item) => {
  item.addEventListener('click', calculateDrawerPosition);
});
document.querySelectorAll(menuSelectors.cartButton).forEach((item) => {
  item.addEventListener('click', calculateDrawerPosition);
});

calculateDrawerPosition();
body.addEventListener('click', clickedOutside);
